import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ElementRef,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  TemplateRef,
  HostListener
} from '@angular/core';

import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger } from '@angular/material/menu'; // Added MatMenuTrigger
import { SelectionModel } from '@angular/cdk/collections';
import { Router, ActivatedRoute } from '@angular/router';
import { ColumnSettingsMenuComponent } from './column-settings-menu/column-settings-menu.component'; // added by Deepak on 23-03-2026 for column setting menu in application and staff table.
import { CommonPaginationData } from '../common-pagination/common-pagination.component.model';
import { ChangeDetectorRef, AfterViewInit } from '@angular/core'; // added by Deepak on 30-03-2026 for triggering change detection after view init in application and staff table.
import { svgs } from 'src/assets/export.assets';
import { CommonConfirmationModalData } from '../common-confirmation-modal/common-confirmation-modal.component.model';
import { WorkflowContextService } from 'src/app/services';
export interface TableColumn {
  key: string;
  apiKey?: string;
  label?: string;
  headerType?: 'text' | 'icon' | 'checkbox' | 'component' | 'status' | 'badge' | 'template';
  cellType?: 'text' | 'icon' | 'radio' | 'checkbox' | 'component' | 'template' | 'status' | 'badge' | 'lengthyText';
  cellTemplate?: TemplateRef<any>
  headerTemplate?:TemplateRef<any>
  icon?: string;
  component?: any;
  width?: string;
  // Added by amisha  for differet cell color depending on application and staff table on 21-01-2026
  textColor?: string;
  hidden?: boolean; //added by Vipul on 30-01-2026 to hide columns by default
  exportable?: boolean;// added by Vipul on 30-01-2026 to give option to user to select which column should be used to export reports
  showExportOption?: boolean;// added by Vipul on 30-01-2026 to give option to user to select which column should be used to export reports
  expandable?: boolean;//Added by amisha on 9-02-2026 for inline expanded row card design in application table and staff table.
  hideable?: boolean; // Added by Krutika
  sortable?: boolean; // Added by furkan for optional sort icon 23-03-2026
  hideMenu?: boolean; // Added by furkan for optional menu icon 23-03-2026
  headerAlignTop?: boolean; // Added by furkan to support top alignment for colun headers
  componentInputs?: (row: any) => any;
  componentOutputs?: { [eventName: string]: (value: any) => void };
  badgeField?: string;        // e.g. 'unreadCount'
  hideZeroBadge?: boolean;    // default true
  cursor?:string
  // Added by amisha on 05/07/2027 to support existing icon table configurations under explicit typing.
  // Reason: applicant tables already pass dynamic icon styling helpers that must remain valid after typing columns.
  iconColor?: (row: any) => string;
  classFn?: (row: any) => string;
  // Added by amisha on 05/07/2027 to allow pages to opt individual columns into keyboard focus rules.
  // Reason: shared tables now need configurable keyboard behavior without forcing every cell into the tab sequence.
  keyboardFocusable?: boolean;
}

@Component({
  selector: 'wm-common-table',
  standalone: false,

  templateUrl: './common-table.component.html',
  styleUrls: ['./common-table.component.css'],

  encapsulation: ViewEncapsulation.None
})


export class CommonTableComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  errorIcon= svgs.errorIcon.name;
  closeInlineApplicationModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Close Application',
    modalSubDescp: 'Please make sure you do not have any unsaved changes before closing this application.',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default',
    customCloseAccepted: true
  };
  @Input() columns: TableColumn[] = [];
  // Added by amisha on 2026-08-24 to let common-table consumers opt into configured fixed widths.
  // Reason: server-side sorting must not resize columns from the text values returned on the next page.
  @Input() fixedColumnWidths: boolean = false;
  @Input() data: any[] = [];

  @Input() tableClass: string = '';
  @Input() rowClass: string = '';
  @Input() cellClass: string = '';
  @Input() headerClass: string = '';
  @Input() tableType: 'Applicant' | 'Staff' = 'Applicant'; // updated by priya on 23-09-2026. Reason: Renamed the table type from Application to Applicant to accurately identify to scope Applicant-specific (Applicant-side tables) across the common table component
  @Input() showRowsPerPage = false; //added by Vipul on 02-02-2026
  @Input() pageSizeOptions: number[] = [10, 25, 100, 200]; //added by Vipul on 02-02-2026
  @Input() defaultPageSize = 10; //added by Vipul on 02-02-2026
  @Input() pageSize = 10; //added by Vipul on 02-02-2026
  @Input() selectedRow: any = null; //added by Vipul on 04-02-2026
  @Input() serverSidePagination = false; //added by Vipul on 04-02-2026

  @Input() pageSizeStorageKey = '';
  @Input() totalPages = 0;  //added by Vipul on 05-02-2026
  @Input() currentPage = 0; //added by Vipul on 05-02-2026
  @Input() totalRecords = 0;
  @Input() selectedRecords = 0;
  @Input() showTotalRecords = false;
  @Input() isLoading: boolean = false;  //added by Vipul on 05-02-2026
  @Input() errorMessage: string = ''; //added by Vipul on 05-02-2026
  @Input() showRetryButton: boolean = true; //added by Vipul on 05-02-2026
  @Input() showErrorIcon:boolean = false;
  @Input() hasExtraBottomSpacing = false; //added by Omkar on 24-03-2026
  @Input() fixedPagination = false; //added by Omkar on 24-03-2026
  @Input() enableTableScroll = false; //added by Omkar on 24-03-2026
  @Input() loaderType: 'Skeleton' | 'Circular' = 'Skeleton'; // added by Vipul on 25-03-2026
  @Input() updateColumnsOnClose = false; // Added property for optional close behavior
@Input() isMobileTabletViewScrollingAndPaginationChanges = true;//updated by priya on 01-09-2026 for mobile and tablet view
  @Output() retry = new EventEmitter<void>();//added by Vipul on 05-02-2026

  @Output() pageChange = new EventEmitter<number>();  //added by Vipul on 05-02-2026

  @Output() radioSelect = new EventEmitter<any>();  //added by Vipul on 05-02-2026
  @Output() checkboxSelect = new EventEmitter<any>(); //added by Vipul on 05-02-2026
  @Output() rowCheckboxClick = new EventEmitter<any>();
  @Output() headerCheckboxClick = new EventEmitter<any>();
  //Added  by amisha on 9-02-2026 for inline expanded row card design in application table and staff table.
  // 🔹 Expansion controls (OPTIONAL – default = no change)
  @Input() expansionMode: 'inline' | 'overlay' | 'none' = 'none';
  @Input() expandOn: 'row' | 'cell' = 'row';
  // Added by Amisha on 2026-09-21.
  // Reason: non-application tables need their parent page and optional subtab in the mobile expansion header.
  @Input() mobileInlineExpansionParentTitle = '';
  @Input() mobileInlineExpansionSubTabTitle = '';
  // Added by amisha on 2026-04-30
  // Reason: let specific screens preserve only the inline edit query param on collapse
  // without changing the shared-table default behavior everywhere else.
  @Input() preserveEditQueryParamOnCollapse = false;
  // Added by amisha on 05/07/2027 to let pages choose cell or row keyboard focus behavior.
  // Reason: My Applications needs full-row focus while other shared-table consumers may still use cell-level focus.
  @Input() enableCellKeyboardFocus = false;
  @Input() cellKeyboardFocusMode: 'row' | 'cell' | 'none' = 'none';
  @Input() focusableCellKeys: string[] = [];
  @Input() disableHeaderKeyboardFocus = false;
  @Input() disablePaginationKeyboardFocus = false;
  @Input() enableRowKeyboardFocus = false;
  @Input() rowKeyboardFocusable: ((row: any) => boolean) | null = null;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef, // Added by Deepak on 30/03/2026
         public context: WorkflowContextService,

  ) { }

  // 🔹 Expansion component
  @Input() expandedComponent?: any;
  @Input() expandedComponentInputs?: (row: any) => any;

  @Input({ required: false }) expansionTemplate?: TemplateRef<any>

  // Allows inline expanded components to emit events back to the hosting page. added by amisha
  @Input() expandedComponentOutputs?: { [eventName: string]: (value: any) => void };


  @Output() rowClick = new EventEmitter<any>();
  @Output() iconClick = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<{
    checked: boolean;
    row: any;
  }>();
  @Output() exportColumnsChange = new EventEmitter<string[]>(); //added by Vipul on 30-01-2026
  @Output() rowsPerPageChange = new EventEmitter<number>(); //added by Vipul on 02-02-2026

  @Input() displayedColumns?: string[] = [];//updated by priya 04-02-2026 from normal variable to input
  @ViewChild('columnMenuComp') columnMenuComp!: ColumnSettingsMenuComponent;

  //  Added by furkan to control the hidden menu trigger
  @ViewChild('menuProxyTrigger', { read: MatMenuTrigger }) menuProxyTrigger!: MatMenuTrigger;
  @ViewChild('menuProxyTrigger', { read: ElementRef }) menuProxyTriggerEl!: ElementRef;
  private columnMenuAnchor: HTMLElement | null = null;

  allColumns: TableColumn[] = [];
  dataSource = new MatTableDataSource<any>([]);

  // Added by Vipul on 30-01-2026
  columnOptions: {
    key: string;
    label: string;
    visible: boolean;
    exportable: boolean;
    showExportToggle: boolean;
  }[] = [];
  exportColumns: Set<string> = new Set();
  // Ended by Vipul on 02-02-2026
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('wrapperRef', { static: false }) wrapperRef!: ElementRef;
  // Added by amisha on 2026-09-15.
  // Reason: render the mobile inline-expansion screen at document level so scrolling table ancestors cannot clip it.
  private mobileInlineOverlayElement: HTMLElement | null = null;

  @ViewChild('mobileInlineOverlay')
  set mobileInlineOverlay(element: ElementRef<HTMLElement> | undefined) {
    if (!element) {
      this.mobileInlineOverlayElement = null;
      document.body.classList.remove('common-table-mobile-overlay-open');
      return;
    }

    this.mobileInlineOverlayElement = element.nativeElement;
    // Added by amisha on 2026-09-15.
    // Reason: move the white mobile expansion screen outside transformed or scrolling table ancestors.
    if (this.mobileInlineOverlayElement.parentElement !== document.body) {
      document.body.appendChild(this.mobileInlineOverlayElement);
    }
    document.body.classList.add('common-table-mobile-overlay-open');
  }
  // added by priya 04-02-2026
  @Output() displayedColumnsChange = new EventEmitter<string[]>();


  @Output() sortChanged = new EventEmitter<{
    sortField: string | null;
    sortDescending: boolean | null;
  }>();
  // Added by amisha on 2026-06-01 to let host screens decide how to present visible-column limit warnings.
  // Reason: Janus now needs the shared confirmation modal instead of a toaster for the 8th-column warning.
  @Output() visibleColumnLimitReached = new EventEmitter<string>();
  @Input() persistColumns: boolean = false;
  // Added by amisha on 2026-06-01 to let specific screens enforce a visible-column cap through the shared menu.
  // Reason: Janus needs to limit users to 7 visible data columns at a time and show a consistent warning.
  @Input() maxVisibleColumns: number | null = null;
  @Input() maxVisibleColumnsMessage: string = '';

  // Added by amisha on 04/20/2026 to size skeleton placeholders from the real table viewport instead of a fixed count.
  // Reason: large screens were showing too few loader rows and the hardcoded pattern was getting clipped.
  skeletonRows = Array.from({ length: 14 }, (_, index) => index);
  // Added by amisha on 04/20/2026 to retain the exact rendered header widths for the refresh skeleton.
  // Reason: applicant loaders were still being cut off on wider tables because fallback widths did not match the real columns.
  private measuredSkeletonColumnWidths: string[] = [];
  @Input() loadingData: boolean = false
  @Input() loadingDataForApplication: boolean = false//added by priya for 19-04-2026
  @Input() fullHeight: boolean = false; //added by Vipul on 302-04-2026
  @Input() tableHeight: string = '400px'; //added by Vipul on 302-04-2026
  @Input() onlySimpleClose: boolean = false;

  // end by priya 04-02-2026

  paginatorReady = false;
  private hasCompletedInitialLoad = false;
  private clientPageIndex = 0;
  private clientTotalPages = 0;

  @Input({required:false}) clientSortState: Sort = { active: '', direction: '' };
  // Added by amisha on 2026-04-03 to keep truncated text tooltips working on touch devices and close them safely on outside tap/scroll.
  private activeTouchTooltip: MatTooltip | null = null;
  private activeTouchTooltipHost: HTMLElement | null = null;
  // Added by amisha on 2026-04-03 to close any touch-opened tooltip when table/page scrolling starts so it never stays detached from the text.
  private onGlobalScrollOrMove = () => this.hideActiveTouchTooltip();

  pages: number[] = [];
  selection = new SelectionModel<any>(true, []);
  @Input({ required: false }) expandedRow: any | null = null;//Added  by amisha on 9-02-2026 for inline expanded row card design in application table and staff table.


  internalData: any[] = [];

  // Start Code added by Sanchit on 07/14/2026
  onDisplayedColumnsUpdated(columns: string[]) {
    if (!this.updateColumnsOnClose) {
      return;
    }

    this.displayedColumns = [...columns];

    if (this.persistColumns) {
      localStorage.setItem(
        `columns-${this.tableType}`,
        JSON.stringify(this.displayedColumns)
      );
    }

    this.displayedColumnsChange.emit(this.displayedColumns);
  }
  // End Code added by Sanchit on 07/14/2026

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isLoading']) {
      const prev = changes['isLoading'].previousValue;
      const curr = changes['isLoading'].currentValue;
      if (prev === true && curr === false) {
        this.hasCompletedInitialLoad = true;
      }
    }

    if (changes['data']) {

      // 🔍 specifically log unreadCount per row
      (changes['data'].currentValue || []).forEach((row: any) => {
      });
    }

    if (changes['defaultPageSize'] && changes['defaultPageSize'].currentValue) {
      this.pageSize = changes['defaultPageSize'].currentValue;
      if (!this.serverSidePagination) {
        this.clientPageIndex = 0;
      }
    }

    if (changes['data'] && changes['data'].currentValue !== changes['data'].previousValue) {
      this.refreshTableData();
    }

    if (changes['columns'] && changes['columns'].currentValue !== changes['columns'].previousValue) {
      this.allColumns = this.columns ?? [];

      this.displayedColumns = this.columns
        .filter(c => !c.hidden)
        .map(c => c.key);
      // added by priya 04-02-2026

      if (this.persistColumns) {
        const saved = localStorage.getItem(`columns-${this.tableType}`);
        if (saved) {
          const keys: string[] = JSON.parse(saved);
          this.displayedColumns = this.columns
            .filter(c => !c.hidden)
            .map(c => c.key)
            .filter(k => {
               // Ensure columns marked as hideMenu: true or hideable: false are always loaded
               const col = this.columns.find(x => x.key === k);
               return keys.includes(k) || col?.hideMenu === true || col?.hideable === false;
            });
        } else {
          this.displayedColumns = this.columns.filter(c => !c.hidden).map(c => c.key);
        }
      } else {
        this.displayedColumns = this.columns.filter(c => !c.hidden).map(c => c.key);
      }
      // end by priya 04-02-2026

      this.syncExportColumns();
    }

    // Added by amisha on 04/20/2026 to keep the skeleton layout synced with data, column, and viewport changes.
    // Reason: responsive loaders should update immediately instead of keeping stale row counts.
    this.updateSkeletonRows();
  }

  // added by priya 04-02-2026

  handleSortChange(sort: Sort): void {

    this.clientSortState = sort;

    if (!sort.active) {
      if (!this.serverSidePagination) {
        this.refreshClientPageData();
      }
      return;
    }

    if (sort.direction === '') {
      this.sortChanged.emit({
        sortField: null,
        sortDescending: null
      });
      if (!this.serverSidePagination) {
        this.refreshClientPageData();
      }
      return;
    }

    this.sortChanged.emit({
      sortField: sort.active,
      sortDescending: sort.direction === 'desc'
    });

    if (!this.serverSidePagination) {
      this.refreshClientPageData();
    }
  }
  // end by priya 04-02-2026


  // Added by Vipul on 30-01-2026
  get hasExportOptions(): boolean {
    return this.columns?.some(c => c.showExportOption);
  }

  private syncExportColumns() {
    this.exportColumns.clear();

    this.columns.forEach(col => {
      if (col.showExportOption !== false) {
        this.exportColumns.add(col.key);
      }
    });

    this.exportColumnsChange.emit(this.getExportColumns());
  }

  toggleExportColumn(colKey: string) {
    if (this.exportColumns.has(colKey)) {
      this.exportColumns.delete(colKey);
    } else {
      this.exportColumns.add(colKey);
    }
    this.exportColumnsChange.emit(this.getExportColumns());
  }

  getExportColumns(): string[] {
    return Array.from(this.exportColumns);
  }

  onPageSizeChange(size: number) {
      this.savePageSize(size);

  this.pageSize = size;
    if (this.serverSidePagination) {
      this.rowsPerPageChange.emit(size);
    } else {
      this.pageSize = size;
      this.clientPageIndex = 0;
      this.refreshClientPageData();
    }
  }

  onRetry() {
    this.retry.emit();
  }

  // Added by Vipul on 30-01-2026

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  toggleAllRows(checked: boolean) {
    if (checked) {
      this.selection.select(...this.dataSource.data);
    } else {
      this.selection.clear();
    }
  }

  toggleRow(row: any, checked: boolean) {
    checked ? this.selection.select(row) : this.selection.deselect(row);
    this.checkboxSelect.emit(row);

  }
  // added by priya 17-04-2026
  isMobileView = false;


  @HostListener('window:resize')
  onResize() {
    this.checkScreen();
    this.updateSkeletonRows();
    this.updateColumnMenuMaxHeight();
  }

  checkScreen() {
    // Updated by amisha on 2026-09-15.
    // Reason: the same mobile inline-expansion treatment must work for Staff and Application tables.
    this.isMobileView = window.innerWidth <= 600;
  }
  // end by priya 17-04-2026

  ngOnInit() {
    this.checkScreen();  // added by priya 17-04-2026


    const storedPageSize = this.getStoredPageSize();

this.pageSize = storedPageSize ?? this.defaultPageSize;
    this.allColumns = this.columns;
    this.displayedColumns = this.columns
      .filter(c => !c.hidden)
      .map(c => c.key);
    this.syncExportColumns();
    // added by priya 04-02-2026

    if (this.persistColumns) {

      const saved = localStorage.getItem(`columns-${this.tableType}`);
      if (saved) {
        const keys: string[] = JSON.parse(saved);
        this.displayedColumns = this.columns
          .filter(c => !c.hidden)
          .map(c => c.key)
          .filter(k => {
             // Ensure columns marked as hideMenu: true or hideable: false are always loaded
             const col = this.columns.find(x => x.key === k);
             return keys.includes(k) || col?.hideMenu === true || col?.hideable === false;
          });
      } else {
        this.displayedColumns = this.columns.filter(c => !c.hidden).map(c => c.key);
      }
    } else {
      this.displayedColumns = this.columns.filter(c => !c.hidden).map(c => c.key);
    }
    // end by priya 04-02-2026

    this.refreshTableData();

  }

  ngOnDestroy() {
    this.wrapperRef?.nativeElement
      ?.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('scroll', this.onGlobalScrollOrMove, true);
    document.removeEventListener('touchmove', this.onGlobalScrollOrMove, true);
    document.removeEventListener('wheel', this.onGlobalScrollOrMove, true);
    // Added by amisha on 2026-09-15.
    // Reason: release the mobile screen and body scroll lock when the common table is destroyed.
    document.body.classList.remove('common-table-mobile-overlay-open');
    this.mobileInlineOverlayElement?.remove();
    this.mobileInlineOverlayElement = null;
    this.hideActiveTouchTooltip();
  }

  toggleColumn(colKey: string) {

    const column = this.columns.find(c => c.key === colKey);

    if (column?.hideable === false || column?.hideMenu === true) {
      return;
    }

    const shown = new Set(this.displayedColumns);
    if (shown.has(colKey)) {
      shown.delete(colKey);
    } else {
      shown.add(colKey);
    }

    this.displayedColumns = this.columns
      .filter(c => shown.has(c.key))
      .map(c => c.key);
    // added by priya 04-02-2026

    if (this.persistColumns) {
      localStorage.setItem(`columns-${this.tableType}`, JSON.stringify(this.displayedColumns));
    }

    // Start Code added by Sanchit on 07/14/2026
    // this.displayedColumnsChange.emit(this.displayedColumns);
    if (!this.updateColumnsOnClose) {
      this.displayedColumnsChange.emit(this.displayedColumns);
    }
    // End Code added by Sanchit on 07/14/2026
    // end by priya 04-02-2026

  }

  // Added by furkan for column settings menu
  openColumnMenu(event: MouseEvent) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();

      const target = event.currentTarget as HTMLElement;
      const rect = target.getBoundingClientRect();
      this.columnMenuAnchor = target;
      this.updateColumnMenuMaxHeight();

      const proxyEl = this.menuProxyTriggerEl.nativeElement;

      proxyEl.style.left = rect.left + 'px';
      proxyEl.style.top = rect.top + 'px';
      proxyEl.style.width = rect.width + 'px';
      proxyEl.style.height = rect.height + 'px';
    }
      this.menuProxyTrigger.openMenu();
  }

  private updateColumnMenuMaxHeight(): void {
    if (!this.columnMenuAnchor) {
      return;
    }

    const viewportMargin = 16;
    const anchorRect = this.columnMenuAnchor.getBoundingClientRect();
    const availableBelow = window.innerHeight - anchorRect.bottom - viewportMargin;
    const availableAbove = anchorRect.top - viewportMargin;
    const availableHeight = Math.max(availableBelow, availableAbove);
    const viewportHeight = Math.max(0, window.innerHeight - viewportMargin * 2);

    document.documentElement.style.setProperty(
      '--common-table-column-menu-max-height',
      `${Math.floor(Math.min(availableHeight, viewportHeight))}px`
    );
  }

  // Added by amisha on 2026-04-03 to close the active touch tooltip on horizontal table scroll as soon as the wrapper starts moving.
  private onScroll = () => {
    const wrapper = this.wrapperRef.nativeElement;
    wrapper.classList.toggle('scrolled', wrapper.scrollLeft > 0);
    this.hideActiveTouchTooltip();
  };

  // Added by amisha on 2026-04-03 to listen for wrapper, page, and touch scroll movement so touch-opened tooltips always close during scrolling.
  ngAfterViewInit() {
    if (!this.serverSidePagination) {
      //updated by amisha on 04/16/2024
      // Keep MatSort disabled for server-side tables so Angular Material does not do a transient
      // client-side reorder before the backend-sorted response is rendered.
      this.dataSource.sort = this.sort;
      setTimeout(() => {
        this.paginatorReady = true;
        this.refreshClientPageData();
      });
    }
    const wrapper = this.wrapperRef.nativeElement;
    wrapper.addEventListener('scroll', this.onScroll);
    document.addEventListener('scroll', this.onGlobalScrollOrMove, true);
    document.addEventListener('touchmove', this.onGlobalScrollOrMove, true);
    document.addEventListener('wheel', this.onGlobalScrollOrMove, true);

    // Added by amisha on 04/20/2026 to recalculate loader density after the table frame is actually rendered.
    // Reason: the responsive skeleton depends on the real wrapper height.
    this.updateSkeletonRows();
    this.cd.detectChanges(); // Added by Deepak on 30/03/2026 to trigger change detection after view init
  }
  //Added  by amisha on 9-02-2026 for inline expanded row card design in application table and staff table.
  // 🔹 Tracks currently expanded row

  isExpanded(row: any): boolean {
    return this.expandedRow === row;
  }
  isExpandedRow = (_: number, row: any) =>
    this.expansionMode === 'inline' && this.isExpanded(row);


  toggleExpansion(row: any) {
    if (this.expansionMode === 'none') {
      return
    }
    if(this.expandedRow === null){
      this.expandedRow = row;
      this.rowClick.emit(this.expandedRow);
    }else{
      if(this.expansionMode === 'overlay'){
   this.expandedRow = row;
      this.rowClick.emit(row);      }
else{
this.closeInlineApplicationModalData = {
          ...this.closeInlineApplicationModalData,
          open: true
        }
    }
  }
    // Updated by amisha on 2026-09-15.
    // Reason: only desktop/tablet inline rows need to be scrolled into view; mobile opens a full-screen overlay.
    if (this.showInlineExpansionInTable) {
      this.scrollExpandedRowIntoView();
    }
  }
   handleCloseInlineApplicationModalAccepted() {
    this.closeInlineApplicationModalData = {
          ...this.closeInlineApplicationModalData,
          open: false
        }
    this.expandedRow = null;
    this.rowClick.emit(null);
    if(this.onlySimpleClose === true)return
    const currentEditId = this.route.snapshot.queryParamMap.get('edit');
    // Added by amisha on 2026-04-30
    // Reason: on opted-in screens, collapse should close only the inline edit state and keep
    // existing search/filter params instead of wiping out the full page query string.
    if (this.preserveEditQueryParamOnCollapse && currentEditId) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { edit: null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
      return;
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      queryParamsHandling: '',
      replaceUrl: true
    });

   }

  handleCloseInlineApplicationModalRejected() {
this.closeInlineApplicationModalData = {
          ...this.closeInlineApplicationModalData,
          open: false
        }
  }



  onRowClick(row: any) {
    const selectedText = window.getSelection()?.toString();
    if (selectedText?.trim()) {
      return;

    }
    //Added  by amisha on 9-02-2026 for inline expanded row card design in application table and staff table.
    if (this.expandOn === 'row') {
      this.toggleExpansion(row);
    }else{
this.rowClick.emit(row);
    }
  }

  onTextCellClick(event: MouseEvent, row: any, col: TableColumn): void {
    //Added by amisha on 2024/04/14
    // Added because the inner text wrapper was swallowing clicks with stopPropagation(),
    // which made row/overlay open only when clicking outside the text. Now we stop propagation
    // only for true expand-on-cell tables and let normal row-click tables behave consistently.
    if (col.expandable && this.expandOn === 'cell') {
      event.stopPropagation();
      this.toggleExpansion(row);
    }
  }

  // Added by amisha on 05/07/2027 to centralize opt-in cell focus rules in the shared table.
  // Reason: only specific table columns should become keyboard stops instead of every rendered value.
  isCellKeyboardFocusable(col: TableColumn): boolean {
    if (!this.enableCellKeyboardFocus) {
      return false;
    }

    if (col.keyboardFocusable === false) {
      return false;
    }

    if (this.focusableCellKeys?.length) {
      return this.focusableCellKeys.includes(col.key);
    }

    if (col.keyboardFocusable === true) {
      return true;
    }

    return !['icon', 'checkbox', 'radio', 'badge'].includes(col.cellType ?? '');
  }

  // Added by amisha on 05/07/2027 to support keyboard activation for focusable table cells.
  // Reason: focused shared-table cells should open the same destination as their configured click behavior.
  onCellKeydown(event: KeyboardEvent, row: any, col: TableColumn): void {
    if (!this.isCellKeyboardFocusable(col)) {
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (this.cellKeyboardFocusMode === 'cell' && col.expandable && this.expandOn === 'cell') {
      this.toggleExpansion(row);
      return;
    }

    if (this.cellKeyboardFocusMode === 'row') {
      this.onRowClick(row);
    }
  }

  // Added by amisha on 05/07/2027 to expose row-level keyboard focus as a shared-table option.
  // Reason: My Applications requires the whole row to highlight and activate instead of a single cell only.
  isRowKeyboardFocusable(row: any): boolean {
    if (!this.enableRowKeyboardFocus) {
      return false;
    }

    return this.rowKeyboardFocusable ? this.rowKeyboardFocusable(row) : true;
  }

  // Added by amisha on 05/07/2027 to activate focused rows from the keyboard.
  // Reason: row focus in My Applications should behave the same as clicking the row with the mouse.
  onRowKeydown(event: KeyboardEvent, row: any): void {
    if (!this.isRowKeyboardFocusable(row)) {
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    this.onRowClick(row);
  }

  get effectiveDisplayedColumns(): string[] {
    // Updated by amisha on 2026-09-15.
    // Reason: the collapse column belongs to the inline table row, not the mobile expansion screen.
    if (this.showInlineExpansionInTable) {
      return [...this.displayedColumns, 'collapse'];
    }
    return this.displayedColumns;
  }

  // Added by amisha on 2026-09-15.
  // Reason: preserve the original inline table-row layout above the existing 600px mobile breakpoint.
  get showInlineExpansionInTable(): boolean {
    return this.expansionMode === 'inline' && !!this.expandedRow && !this.isMobileView;
  }

  // Added by amisha on 2026-09-15.
  // Reason: show expanded staff/application details in a full-screen screen only at mobile width.
  get showMobileInlineExpansionOverlay(): boolean {
    return this.expansionMode === 'inline' && !!this.expandedRow && this.isMobileView;
  }

  // Added by amisha on 2026-09-15.
  // Reason: display the selected application's number in the mobile header across common row shapes.
  get mobileOverlayApplicationNumber(): string {
    const row = this.expandedRow;
    return row?.['App #']
      ?? row?.applicationNumber
      ?? row?.applicationNo
      ?? row?.appNo
      ?? row?.permitNumber
      ?? '';
  }

  // Added by Amisha on 2026-09-21.
  // Reason: retain the application-number header for application rows and provide a useful
  // parent/subtab fallback for shared inline expansions such as Reports - Data Sets.
  get mobileInlineExpansionHeaderTitle(): string {
    const applicationNumber = String(this.mobileOverlayApplicationNumber ?? '').trim();
    if (applicationNumber) {
      return `Application #: ${applicationNumber}`;
    }

    const configuredTitle = [
      this.mobileInlineExpansionParentTitle,
      this.mobileInlineExpansionSubTabTitle
    ]
      .map(title => title?.trim())
      .filter((title, index, titles) => !!title && titles.indexOf(title) === index)
      .join(' - ');

    return configuredTitle || this.getMobileInlineExpansionRouteTitle();
  }

  // Added by Amisha on 2026-09-21.
  // Reason: direct shared-table consumers that do not provide labels still need a readable
  // mobile header derived from their current parent route and optional child route.
  private getMobileInlineExpansionRouteTitle(): string {
    const ignoredSegments = new Set([
      'admin',
      'client-admin',
      'client-admin-janus',
      'janus'
    ]);
    const routeSegments = this.router.url
      .split(/[?#(]/)[0]
      .split('/')
      .map(segment => segment.trim())
      .filter(segment =>
        !!segment &&
        !ignoredSegments.has(segment.toLowerCase()) &&
        !/^\d+$/.test(segment) &&
        !/^[0-9a-f]{8}-[0-9a-f-]{27,}$/i.test(segment)
      )
      .map(segment => this.formatMobileInlineExpansionRouteSegment(segment))
      .filter((segment, index, segments) =>
        !!segment && segment.toLowerCase() !== segments[index - 1]?.toLowerCase()
      );

    if (!routeSegments.length) {
      return 'Details';
    }

    return routeSegments.slice(-2).join(' - ');
  }

  // Added by Amisha on 2026-09-21.
  // Reason: convert route tokens such as data-sets and dataexport into user-facing tab labels.
  private formatMobileInlineExpansionRouteSegment(segment: string): string {
    const normalizedSegment = segment.toLowerCase();
    const knownLabels: Record<string, string> = {
      datasets: 'Data Sets',
      'data-sets': 'Data Sets',
      dataexport: 'Data Export'
    };

    if (knownLabels[normalizedSegment]) {
      return knownLabels[normalizedSegment];
    }

    return decodeURIComponent(segment)
      .replace(/[-_]+/g, ' ')
      .replace(/\b\w/g, character => character.toUpperCase());
  }
  // 🔹 Normal row (default)
  isNormalRow = (_: number, row: any) => !this.isExpanded(row);


  onIconClick(event: MouseEvent, icon: string, row: any) {
    event.stopPropagation();
    this.iconClick.emit({ icon, row });
  }

  getCellTooltip(row: any, col: TableColumn): string | null {
    const value = row?.[col.key];

    if (value === null || value === undefined) {
      return null;
    }

    const text = String(value).trim();
    return text ? text : null;
  }

  // Added by amisha on 2026-04-01 to preserve the old tooltip behavior in normal tables and show full values only while an inline row is expanded.
  getInlineCellTooltip(
    row: any,
    col: TableColumn,
    fallback: string | null = null
  ): string | null {
    if (!this.expandedRow) {
      return fallback;
    }

    return this.getCellTooltip(row, col);
  }

  // Added by amisha on 2026-04-03 to show the full value only when truncated common-table text is hovered or tapped, without opening tooltips during normal scroll.
  updateOverflowTooltip(
    event: Event,
    tooltip: MatTooltip,
    row: any,
    col: TableColumn
  ): void {
    const text = this.getCellTooltip(row, col);
    const host = event.currentTarget as HTMLElement | null;
    const measuredElement =
      (host?.querySelector('.common-text') as HTMLElement | null) ?? host;

    const shouldShow = !!text && !!measuredElement &&
      measuredElement.scrollWidth > measuredElement.clientWidth;

    tooltip.message = shouldShow ? text : '';
    tooltip.disabled = !shouldShow;

    if (!shouldShow) {
      tooltip.hide(0);
      if (this.activeTouchTooltip === tooltip) {
        this.hideActiveTouchTooltip();
      }
      return;
    }

    tooltip.show(0);
  }

  // Added by amisha on 2026-04-03 to open the same Material tooltip on touch devices only after an intentional tap on truncated text.
  handleTouchTooltipClick(
    event: Event,
    tooltip: MatTooltip,
    row: any,
    col: TableColumn
  ): void {
    if (!this.isTouchViewport()) {
      return;
    }

    const text = this.getCellTooltip(row, col);
    const host = event.currentTarget as HTMLElement | null;
    const measuredElement =
      (host?.querySelector('.common-text') as HTMLElement | null) ?? host;

    const shouldShow = !!text && !!measuredElement &&
      measuredElement.scrollWidth > measuredElement.clientWidth;

    if (!shouldShow) {
      this.hideActiveTouchTooltip();
      return;
    }

    event.stopPropagation();

    if (this.activeTouchTooltip === tooltip) {
      return;
    }

    this.hideActiveTouchTooltip();
    this.activeTouchTooltip = tooltip;
    this.activeTouchTooltipHost = host;
    tooltip.message = text;
    tooltip.disabled = false;
    tooltip.show(0);
  }

  hideOverflowTooltip(tooltip: MatTooltip): void {
    if (this.activeTouchTooltip === tooltip) {
      return;
    }

    tooltip.hide(0);
  }

  // Added by amisha on 2026-04-03 to close the active touch tooltip only when the user taps outside the same truncated-text target.
  @HostListener('document:click', ['$event'])
  closeTouchTooltipOnOutsideInteraction(event: Event): void {
    if (!this.activeTouchTooltip || !this.activeTouchTooltipHost) {
      return;
    }

    const target = event.target as Node | null;
    if (target && this.activeTouchTooltipHost.contains(target)) {
      return;
    }

    this.hideActiveTouchTooltip();
  }

  // Added by amisha on 2026-04-03 to centralize touch-tooltip cleanup for outside click, scroll, and overflow state changes.
  private hideActiveTouchTooltip(): void {
    if (this.activeTouchTooltip) {
      this.activeTouchTooltip.hide(0);
      this.activeTouchTooltip = null;
    }

    this.activeTouchTooltipHost = null;
  }

  private isTouchViewport(): boolean {
    return typeof window !== 'undefined' && window.innerWidth <= 1024;
  }

  generatePages() {
    if (this.serverSidePagination) return;
    const total = this.clientTotalPages;
    if (!total || total === Infinity) {
      this.pages = [];
      return;
    }
    this.pages = Array.from({ length: total }, (_, i) => i);
  }

  goToPage(page: number) {
    if (this.serverSidePagination) {
      this.pageChange.emit(page);
    } else {
      this.clientPageIndex = page;
      this.refreshClientPageData();
    }
  }

  goToNext() {
    if (this.serverSidePagination) {
      if (this.currentPage < this.totalPages - 1) {
        this.pageChange.emit(this.currentPage + 1);
      }
    } else {
      if (this.clientPageIndex < this.clientTotalPages - 1) {
        this.clientPageIndex += 1;
        this.refreshClientPageData();
      }
    }
  }

  goToPrevious() {
    if (this.serverSidePagination) {
      if (this.currentPage > 0) {
        this.pageChange.emit(this.currentPage - 1);
      }
    } else {
      if (this.clientPageIndex > 0) {
        this.clientPageIndex -= 1;
        this.refreshClientPageData();
      }
    }
  }

  goToFirst() {
    if (this.serverSidePagination) {
      this.pageChange.emit(0);
    } else {
      this.clientPageIndex = 0;
      this.refreshClientPageData();
    }
  }

  goToLast() {
    if (this.serverSidePagination) {
      if (this.totalPages > 0) {
        this.pageChange.emit(this.totalPages - 1);
      }
    } else {
      if (this.clientTotalPages > 0) {
        this.clientPageIndex = this.clientTotalPages - 1;
        this.refreshClientPageData();
      }
    }
  }

  get visiblePages(): (number | 'dots')[] {
    const totalPages = this.serverSidePagination
      ? this.totalPages
      : this.clientTotalPages;

    const current = this.serverSidePagination
      ? this.currentPage
      : this.clientPageIndex;

    const maxVisible = 5;

    if (!totalPages || totalPages <= 1) return [];

    if (totalPages <= maxVisible) {
      return Array.from({ length: totalPages }, (_, i) => i);
    }

    const pages: (number | 'dots')[] = [];

    const start = Math.max(0, current - 2);
    const end = Math.min(totalPages - 1, current + 2);

    if (start > 0) {
      pages.push(0);
      if (start > 1) pages.push('dots');
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 1) {
      if (end < totalPages - 2) pages.push('dots');
      pages.push(totalPages - 1);
    }

    return pages;
  }

  //added by omkar khamkar on 2026-03-23
  get shouldShowPagination(): boolean {
    // Added by amisha on 04/20/2026 to keep pagination visible during refresh loaders.
    // Reason: both the body-only skeleton flow and the collapsed-body blue-line flow should preserve the frame controls.
    if (this.expansionMode === 'inline' && !!this.expandedRow) {
      return false;
    }
    //added by priya on 20-08-2026
   // Hide pagination while the initial table data is loading.

if (this.showInitialSkeletonLoader) {
    return false;
  }
    const hasRows = (this.dataSource?.data?.length ?? 0) > 0;
    const hasLoadingState =
      this.showApplicationBodySkeletonLoader ||
      this.showFixedScrollSkeletonLoader ||
      this.showCollapsedBodyLoader;

      const hasMultiplePages = this.serverSidePagination
    ? this.totalPages > 1
    : this.clientTotalPages > 1;

    return (
      !this.errorMessage &&
      (hasRows || hasLoadingState) &&
      (this.serverSidePagination || this.paginatorReady) &&
      (hasMultiplePages || this.showRowsPerPage)
    );
  }

  get showSkeletonDataLoader(): boolean {
    return this.fixedPagination && this.enableTableScroll;
  }

  get effectiveLoadingData(): boolean {
    return this.loadingData || (this.isLoading && this.hasCompletedInitialLoad);
  }

  // Added by amisha on 04/20/2026 to mirror the currently visible columns in the skeleton loader.
  // Reason: hardcoded placeholder widths were being cut off on larger screens and not matching the active table shape.
  get skeletonColumnWidths(): string[] {
    if (this.measuredSkeletonColumnWidths.length) {
      return this.measuredSkeletonColumnWidths;
    }

    const visibleColumnKeys = this.displayedColumns?.length
      ? this.displayedColumns
      : (this.columns ?? []).filter(col => !col.hidden).map(col => col.key);

    const visibleColumns = (this.columns ?? []).filter(col => visibleColumnKeys.includes(col.key));

    if (!visibleColumns.length) {
      return ['minmax(140px, 1fr)'];
    }

    return visibleColumns.map(col => this.getSkeletonColumnWidth(col));
  }

  // Added by amisha on 04/20/2026 to drive each skeleton row from the same responsive column template.
  // Reason: the loader must stretch with the real table layout on wide and narrow screens.
  get skeletonGridTemplateColumns(): string {
    return this.skeletonColumnWidths.join(' ');
  }

   isMobile= ()=>{
    window.innerWidth <= 768;

   }
  // Added by amisha on 04/20/2026 to identify the application-table refresh state that should keep header and pagination visible.
  // Reason: the first implementation needs a body-only skeleton instead of replacing the full table shell.
get showApplicationBodySkeletonLoader(): boolean {
  const isMobile = window.innerWidth <= 552;

  return this.tableType === 'Applicant'
    && (
      this.loadingDataForApplication ||
      (
        this.isLoading &&
        (
          !isMobile ||
          this.effectiveLoadingData
        )
      )
    );
}
// Added by amisha on 04/20/2026 to identify fixed-pagination refreshes that should render skeletons only inside the body area.
  // Reason: the fixed-header/fixed-pagination staff table should keep the frame visible while rows reload.
  get showFixedScrollSkeletonLoader(): boolean {
    return this.showSkeletonDataLoader && this.effectiveLoadingData;
  }

  // Added by amisha on 04/20/2026 to identify the blue-line refresh state for fully scrollable tables.
  // Reason: the second implementation should collapse only the body rows so the header, progress line, and pagination remain visible.
  get showCollapsedBodyLoader(): boolean {
    return this.tableType === 'Staff' && this.effectiveLoadingData && !this.showSkeletonDataLoader;
  }

  // Added by amisha on 04/20/2026 to identify the initial full-table skeleton state.
  // Reason: the empty-state message should never render underneath the first-load loader in either shared-table implementation.
  get showInitialSkeletonLoader(): boolean {
    return (this.tableType === 'Staff' || this.tableType === 'Applicant') && this.isLoading && !this.effectiveLoadingData && !this.showCollapsedBodyLoader;
}


  get paginationData(): CommonPaginationData {
    const totalPages = this.serverSidePagination
      ? this.totalPages
      : this.clientTotalPages;

    const currentPage = this.serverSidePagination
      ? this.currentPage
      : this.clientPageIndex;

    return {
      variant: this.tableType === 'Staff' ? 'staff' : 'applicant',
      totalPages,
      currentPage,
      pageSize: this.pageSize,
      pageSizeOptions: this.pageSizeOptions,
      showRowsPerPage: this.showRowsPerPage,
      showTotalRecords: this.showTotalRecords,
      visiblePages: this.visiblePages,
      canGoPrevious: currentPage > 0,
      canGoNext: totalPages > 0 && currentPage < totalPages - 1,
      totalRecords: this.totalRecords,
      selectedRecords: this.selectedRecords
    };
  }

  private refreshTableData(): void {
    if (this.serverSidePagination) {
      // Added by amisha on 04/20/2026 to preserve the last rendered application rows during page-change loading.
      // Reason: some pages temporarily clear `data`, and without this guard the table shell collapses before the body overlay can render.
      if (
        this.tableType === 'Applicant' &&
        (this.isLoading || this.loadingDataForApplication) &&
        !(this.data?.length) &&
        (this.dataSource.data?.length ?? 0) > 0
      ) {
        return;
      }

      this.dataSource.data = this.data ?? [];
      return;
    }
    this.refreshClientPageData();
  }

  private refreshClientPageData(): void {
    const fullData = this.data ?? [];
    const effectivePageSize = Math.max(1, this.pageSize || 1);
    const totalPages = Math.ceil(fullData.length / effectivePageSize);

    this.clientTotalPages = totalPages;

    if (totalPages === 0) {
      this.clientPageIndex = 0;
      this.dataSource.data = [];
      this.generatePages();
      return;
    }

    this.clientPageIndex = Math.min(this.clientPageIndex, totalPages - 1);
    this.clientPageIndex = Math.max(this.clientPageIndex, 0);

    const sortedData = this.getClientSortedData(fullData);
    const start = this.clientPageIndex * effectivePageSize;
    const end = start + effectivePageSize;
    this.dataSource.data = sortedData.slice(start, end);

    this.generatePages();
  }

  // Added by amisha on 04/20/2026 to derive responsive loader widths from the current column configuration.
  // Reason: explicit table widths should be reused when present, with sensible fallbacks for icon and status columns.
  private getSkeletonColumnWidth(col: TableColumn): string {
    if (col.width) {
      return col.width;
    }

    if (col.cellType === 'checkbox' || col.headerType === 'checkbox' || col.cellType === 'radio') {
      return '48px';
    }

    if (col.cellType === 'icon' || col.cellType === 'badge') {
      return '72px';
    }

    if (col.cellType === 'status') {
      return '110px';
    }

    if (col.cellType === 'component') {
      return 'minmax(140px, 1fr)';
    }

    return 'minmax(120px, 1fr)';
  }

  // Added by amisha on 04/20/2026 to fill the visible table body with an appropriate number of skeleton rows.
  // Reason: fixed row counts leave empty space on large screens and overflow unevenly on smaller screens.
  private updateSkeletonRows(): void {
    setTimeout(() => {
      const wrapper = this.wrapperRef?.nativeElement as HTMLElement | undefined;
      const wrapperHeight = wrapper?.clientHeight ?? 0;
      const wrapperScrollHeight = wrapper?.scrollHeight ?? 0;
      const wrapperTop = wrapper?.getBoundingClientRect().top ?? 0;
      const estimatedHeaderHeight = 56;
      const estimatedRowHeight = 46;
      const fallbackBodyHeight = 360;
      // Added by amisha on 04/20/2026 to keep the initial full-table skeleton bounded to the visible screen.
      // Reason: first-load placeholders should fit within the current viewport instead of extending the page height.
    // Added by priya on 2026-09-22.
// Reason: On the Janus applicant mobile view, the viewport-based calculation was
// generating excessive initial skeleton rows and increasing the page height.
// Apply the adjusted height calculation only for small to larger mobile
// viewports up to 552px, while preserving existing behavior for other layouts
// and screen sizes.

    const isJanusApplicant = this.context?.janusLayout === 'applicant';
    const isMobile = window.innerWidth <= 552;

const viewportAvailableHeight =isMobile &&
   isJanusApplicant
    ? fallbackBodyHeight
    : Math.max(
        window.innerHeight - wrapperTop - 24,
        fallbackBodyHeight
      );

const bodyHeight = this.showInitialSkeletonLoader
  ? viewportAvailableHeight
  : Math.max(
      wrapperHeight - estimatedHeaderHeight,
      wrapperScrollHeight - estimatedHeaderHeight,
      fallbackBodyHeight
    );
      const rowCount = Math.max(8, Math.ceil(bodyHeight / estimatedRowHeight));
      const headerCells = Array.from(
        wrapper?.querySelectorAll('th.mat-mdc-header-cell, th.mat-header-cell') ?? []
      ) as HTMLElement[];
      const measuredColumnWidths = headerCells
        .map((cell) => Math.ceil(cell.getBoundingClientRect().width))
        .filter((width) => width > 0)
      const totalMeasuredWidth = measuredColumnWidths.reduce((sum, width) => sum + width, 0);
      const availableWidth = Math.floor(wrapper?.clientWidth ?? 0);
      const shouldStretchMeasuredWidths =
        totalMeasuredWidth > 0 &&
        availableWidth > totalMeasuredWidth &&
        (wrapper?.scrollWidth ?? 0) <= availableWidth + 2;
      const normalizedMeasuredWidths = shouldStretchMeasuredWidths
        ? measuredColumnWidths.map((width, index, allWidths) => {
            const isLastColumn = index === allWidths.length - 1;
            if (isLastColumn) {
              const usedWidth = allWidths
                .slice(0, -1)
                .reduce((sum, currentWidth) => sum + Math.round((currentWidth / totalMeasuredWidth) * availableWidth), 0);
              return `${Math.max(0, availableWidth - usedWidth)}px`;
            }

            return `${Math.round((width / totalMeasuredWidth) * availableWidth)}px`;
          })
        : measuredColumnWidths.map((width) => `${width}px`);
      const rowsChanged = this.skeletonRows.length !== rowCount;
      const widthsChanged =
        normalizedMeasuredWidths.length > 0 &&
        (
          normalizedMeasuredWidths.length !== this.measuredSkeletonColumnWidths.length ||
          normalizedMeasuredWidths.some((width, index) => width !== this.measuredSkeletonColumnWidths[index])
        );

      if (rowsChanged) {
        this.skeletonRows = Array.from({ length: rowCount }, (_, index) => index);
      }

      if (widthsChanged) {
        this.measuredSkeletonColumnWidths = normalizedMeasuredWidths;
      }

      if (rowsChanged || widthsChanged) {
        this.cd.detectChanges();
      }
    });
  }

  private getClientSortedData(rows: any[]): any[] {
    if (!this.clientSortState.active || this.clientSortState.direction === '') {
      return [...rows];
    }
    const rowsCopy = [...rows];
    const accessor = this.dataSource.sortingDataAccessor;
    const active = this.clientSortState.active;
    const direction = this.clientSortState.direction === 'desc' ? -1 : 1;

    return rowsCopy.sort((a, b) => {
      const valueA = accessor(a, active);
      const valueB = accessor(b, active);

      const normalizedA = valueA == null ? '' : valueA;
      const normalizedB = valueB == null ? '' : valueB;

      if (normalizedA < normalizedB) return -1 * direction;
      if (normalizedA > normalizedB) return 1 * direction;
      return 0;
    });
  }
  // end by omkar khamkar 2026-03-23

  selectRow(row: any) {
    this.selectedRow = row;

    this.radioSelect.emit(row);
  }
  closeExpansion(): void {
    this.expandedRow = null;
  }
  expandRow(row: any) {
    this.expandedRow = row;
      // Updated by amisha on 2026-09-15.
      // Reason: programmatic mobile expansion opens its own screen and must not scroll an inline table row.
      if (this.showInlineExpansionInTable) {
        this.scrollExpandedRowIntoView();
      }
  }
  // Added by amisha on 25-02-2026 for routing  back when close icon is clicked in inline expanded row card design in application table and staff table.
  collapseRow() {
    this.closeInlineApplicationModalData = {
          ...this.closeInlineApplicationModalData,
          open: true
        }

  }
  // Added by amisha on 25-02-2026 for checkbox select all in header in staff table. */
  toggleSelectAllStaff(checked: boolean) {
    this.dataSource.data.forEach((row: any) => {
      if (row.status !== 'Disabled') {
        row.selected = checked;
      }
    });
    this.headerCheckboxClick.emit(this.dataSource.data)
  }

  onStaffRowCheckboxClick = (row: any, checked: boolean)=>{
    this.checkboxSelect.emit(row)
    for (const r of this.dataSource.data) {
  if (r.id === row.id && r.status !== 'Disabled') {
    r.selected = checked;
    this.rowCheckboxClick.emit(r);
    break;
  }
}
  }

  isAllSelectedStaff(): boolean {
    const rows = this.dataSource.data.filter(r => r.status !== 'Disabled');
    return rows.length > 0 && rows.every(r => r.selected);
  }

  isSomeSelectedStaff(): boolean {
    const rows = this.dataSource.data.filter(r => r.status !== 'Disabled');
    return rows.some(r => r.selected) && !this.isAllSelectedStaff();
  }

  // Added by amisha on 2026-04-01 to bring the opened inline panel into view so users can see the expanded frame immediately.
  private scrollExpandedRowIntoView(): void {
    setTimeout(() => {
      const wrapper = this.wrapperRef?.nativeElement as HTMLElement | undefined;
      const expandedRow = wrapper?.querySelector('.inline-expanded-row:not([hidden])') as HTMLElement | null;

      if (!wrapper || !expandedRow) {
        return;
      }

      const isWrapperScrollable = wrapper.scrollHeight > wrapper.clientHeight + 5;
      if (isWrapperScrollable) {
        const wrapperRect = wrapper.getBoundingClientRect();
        const expandedRect = expandedRow.getBoundingClientRect();
       if (expandedRect.top < wrapperRect.top) {
         wrapper.scrollTop -= wrapperRect.top - expandedRect.top + 12;
       } else if (expandedRect.bottom > wrapperRect.bottom) {
         wrapper.scrollTop += expandedRect.bottom - wrapperRect.bottom + 12;
       }
      } else {
        expandedRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
   }, 100);
  }

  private getPageSizeStorageKey(): string {
  return this.pageSizeStorageKey
    ? `wm-common-table-page-size-${this.pageSizeStorageKey}`
    : '';
}

private getStoredPageSize(): number | null {
  const storageKey = this.getPageSizeStorageKey();

  if (!storageKey) {
    return null;
  }

  const storedPageSize = localStorage.getItem(storageKey);

  if (!storedPageSize) {
    return null;
  }

  const pageSize = Number(storedPageSize);

  return this.pageSizeOptions.includes(pageSize)
    ? pageSize
    : null;
}

private savePageSize(pageSize: number): void {
  const storageKey = this.getPageSizeStorageKey();

  if (!storageKey) {
    return;
  }

  localStorage.setItem(storageKey, String(pageSize));
}

}
